module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Cap-1-bae9c5f283a48d45a526208681d25704.svg";